export default {
      id: "huge-redo-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.25bf3227.svg#huge-redo",
      toString: function () {
        return this.url;
      }
    }